import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signup-scc_net_terms-click';

/**
 * Track click events for SCC net terms pages

6 options
  START_SCC = "START_SCC",
  SUBMIT_SCC_AGREEMENT = "SUBMIT_SCC_AGREEMENT",
  SUBMIT_SCC_FORM = "SUBMIT_SCC_FORM",
  START_SHOPPING_SCC_STATE = "START_SHOPPING_SCC_STATE",
  SKIP_SCC_AGREEMENT = "SKIP_SCC_AGREEMENT",
  SKIP_SCC_FORM = "SKIP_SCC_FORM",

The START_SHOPPING_SCC_STATE will be appended with state of the soft credit check as well.
 */
export function trackSignupSccNetTermsClick(
  step_clicked: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { step_clicked },
  });
}
